// extracted by mini-css-extract-plugin
export default {"radioWrapper":"CustomRadio_radioWrapper__IIpVl","label":"CustomRadio_label__GVgDx","radioGroup":"CustomRadio_radioGroup__UUjLq"};